import Button from "@mui/material/Button";
import HomeIcon from "@mui/icons-material/Home";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";

function HomeButton() {
  const navigate = useNavigate();

  const Clicked = () => {
    navigate("/linkopeninvoice");
  };
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{ margin: "1rem" }}
    >
      <Button variant="outlined" onClick={Clicked}>
        אישור
      </Button>
    </Stack>
  );
}

export default HomeButton;
